import { render, staticRenderFns } from "./history.vue?vue&type=template&id=273b1f54&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=273b1f54&prod&lang=scss&scoped=true"
import style1 from "./history.vue?vue&type=style&index=1&id=273b1f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b1f54",
  null
  
)

export default component.exports